<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div *ngIf="campanyaId" class="entry-4-modal">
            <label>{{'mantenimientoCampanyas.table.campanya' | translate}}*</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-4-modal">
            <label>{{'global.pais' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="paises" [selectedItem]="newEditForm.get('pais')"
                [placeHolder]="false"></app-filterable-list>
        </div>
        <div *ngIf="campanyaId" class="entry-4-modal">
            <label>{{'mantenimientoCampanyas.table.variedad' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacionId')"
                [disabled]="disabled" [placeHolder]="false"></app-filterable-list>
        </div>
        <div *ngIf="!campanyaId" class="entry-4-modal">
            <label>{{'mantenimientoCampanyas.table.variedad' | translate}} *</label>
            <app-multiselect-list [itemsList]="denominaciones ? denominaciones : []"
                [selectedItem]="newEditForm.get('denominacionId')"
                (shareCheckedList)="shareCheckedListDenominaciones($event)"
                [disabled]="disabled" [initialState]="'allSelected'"></app-multiselect-list>
        </div>
        <div class="entry-4-modal calendar">
            <label>{{'global.fecha.inicio' | translate}} *</label>
            <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
                formControlName="fechaInicio" (click)="fechaInicio.open()">
            <mat-datepicker #fechaInicio></mat-datepicker>
        </div>
        <div class="entry-4-modal calendar">
            <label>{{'global.fecha.fin' | translate}} *</label>
            <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}"
                formControlName="fechaFin" (click)="fechaFin.open()">
            <mat-datepicker #fechaFin></mat-datepicker>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoCampanyas.table.anyo' | translate}} *</label>
            <input type="number" formControlName="anyo">
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="!campanyaId">
            <input type="checkbox" id="duplicarCultivosDeCampanyaAnterior"
                formControlName="duplicarCultivosDeCampanyaAnterior">
            <label
                for="duplicarCultivosDeCampanyaAnterior" style="white-space: nowrap;">{{'mantenimientoCampanyas.table.duplicarCultivosDeCampanyaAnterior'
                | translate}} *</label>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="!campanyaId">
            <input type="checkbox" id="duplicarCultivosMarca" formControlName="duplicarCultivosMarca">
            <label for="duplicarCultivosMarca">{{'mantenimientoCampanyas.table.duplicarCultivosMarca' | translate}}
                *</label>
        </div>
        <div class="entry-4-modal alignment-start">
            <input type="checkbox" id="habilitada" formControlName="habilitada">
            <label for="habilitada">{{'mantenimientoCampanyas.table.habilitada' | translate}} *</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{campanyaId ? ('global.actualizar' | translate) : ('global.insertar' |
        translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>